import React from 'react';
import { COMPETENCY_LEVEL } from 'domain/shared/newVacancy';
import { EnumDropdown, useInputHelper, InputList, InputListTemplateProps } from 'framework/form';
import { Box } from '@mui/material';
import { InputComponentProps } from './types';

const CompetencyInputs = ({
  propertyDetails,
  renderNestedProperties,
  ...props
}: InputListTemplateProps & Pick<InputComponentProps, 'renderNestedProperties'>) => {
  const { getSource } = useInputHelper(props);

  const source = getSource() || '';

  return (
    <>
      <Box
        display="flex"
        gap="20px"
        maxWidth="500px"
        width="100%"
        sx={{
          '> .MuiFormControl-root': {
            mb: '0px !important',
          },
        }}
      >
        <EnumDropdown source={`${source}.value`} options={COMPETENCY_LEVEL} label="" placeholder="Competency level" />

        {renderNestedProperties?.({
          propertiesSource: `${source}.properties`,
          propertiesShema: propertyDetails.properties,
        })}
      </Box>
    </>
  );
};

const CompetencyTemplateFiled = ({ source, propertyDetails, renderNestedProperties }: InputComponentProps) => {
  return (
    <Box
      sx={{
        '> .MuiFormControl-root': {
          mb: '0px !important',
        },
        width: '100%',
        '.removable-input': {
          mt: '0px !important',
          mb: '0px !important',
        },
        '.removable-input:last-of-type': {
          marginBottom: '0px !important',
        },
      }}
    >
      <InputList
        inputTemplate={CompetencyInputs}
        maxFields={1}
        isDeletable={false}
        isAddable={false}
        inputProps={{
          propertyDetails,
          renderNestedProperties,
        }}
        source={`${source}.${propertyDetails.propertyName}`}
        addText="Add Level"
      />
    </Box>
  );
};

export default CompetencyTemplateFiled;
